import { combineReducers } from 'redux';
import * as ActionTypes from '../actions';
import account from './account';
import accounts from './accounts';
import accountPlayer from './accountPlayer';
import accountPlayers from './accountPlayers';
import accountPlayersCSVReport from './accountPlayersCSVReport';
import {
  communication,
  filters as communicationFilters,
  groupMessages,
  me as communicationMe,
} from './communication';
import groupCohortsCSVReport from './groupCohortsCSVReport';
import groupCohortsOrganizationTypeCSVReport from './groupCohortsOrganizationTypeCSVReport';
import userActionsCSVReport from './userActionsCSVReport';
import asqSurveysCSVReport from './asqSurveysCSVReport';
import followUpSurveysCSVReport from './followUpSurveysCSVReport';
import asqSurveyResultsParentEmailSendout from './asqSurveyResultsParentEmailSendout';
import auth from './auth';
import dashboard from './dashboard';
import errorMessage from './errorMessage';
import filters from './filters';
import loaders from './loaders';
import meta from './meta';
import modal from './modal';
import options from './options';
import player from './player';
import reports from './reports';
import survey from './survey';
import surveys from './surveys';
import cardsLibrary from 'components/library/cards/reducer';
import programContentLibrary from 'components/library/programContent/reducer';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { connectRouter } from 'connected-react-router'

const rootReducer = (history) => (state, action) => {
  if (action.type === ActionTypes.SIGN_OUT) {
    const { router } = state;
    state = { router };
  }

  if (action.type === '@@router/LOCATION_CHANGE') {
    window.TIMEOUTS.clearAllTimeouts();
  }

  const appReducer = combineReducers({
    router: connectRouter(history),
    account,
    accounts,
    accountPlayer,
    accountPlayers,
    accountPlayersCSVReport,
    groupCohortsCSVReport,
    groupCohortsOrganizationTypeCSVReport,
    userActionsCSVReport,
    asqSurveysCSVReport,
    followUpSurveysCSVReport,
    asqSurveyResultsParentEmailSendout,
    auth,
    errorMessage,
    dashboard,
    filters,
    loaders,
    meta,
    modal,
    options,
    player,
    reports,
    survey,
    surveys,
    cardsLibrary,
    programContentLibrary,
    communicationFilters,
    communicationMe,
    communication,
    groupMessages,
    loadingBar: loadingBarReducer,
  });

  return appReducer(state, action);
}

export default rootReducer;
